module.exports = __webpack_public_path__ + "media/video1.5003136d.mp4";